const $inject = ['$routeParams', 'dataService', 'settingsService'];

const lbaGridItemCtrl = function ($routeParams, dataService, settingsService) {
  const vm = this;
  const paramId = $routeParams[vm.settings.routeParamId];

  vm.ready = false;
  vm.deleteConfirm = false;
  vm.fields = settingsService.settings.fields;
  vm.cancel = cancel;
  vm.update = update;
  vm.deleteItem = deleteItem;

  if (!dataService.data.activeItem) {
    dataService.get(vm.settings.endpoint, paramId).then((data) => {
      dataService.data.activeItem = data[0];
      vm.ready = true;
    });
  } else {
    vm.ready = true;
  }

  function cancel() {
    vm.grid.cancel();
  }

  function update() {
    vm.grid.update();
  }

  function deleteItem() {
    if(!vm.deleteConfirm) {
        vm.deleteConfirm = true;
    } else {
      vm.grid.deleteItem();
    }
  }
};


lbaGridItemCtrl.$inject = $inject;

export default lbaGridItemCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaGridItem/lbaGridItemCtrl.js